import * as actions from './agentCustom.actions';
import { EntityState, createEntityAdapter } from '@ngrx/entity';
import { createFeatureSelector } from '@ngrx/store';
import { AgentCustomConfigModel } from '@smarttask-common/src/lib/models/Agent/Config/AgentCustomConfigModel';

export const agentCustomAdapter = createEntityAdapter<AgentCustomConfigModel>({
    selectId: (x) => x.user_id,
});
export interface AgentCustomState extends EntityState<AgentCustomConfigModel> {}

export const initialState: AgentCustomState = agentCustomAdapter.getInitialState({});

export function AgentCustomReducers(state: AgentCustomState = initialState, action: actions.AgentCustomActions) {
    switch (action.type) {
        case actions.AgentCustomActionTypes.ADD_AGENT:
            return agentCustomAdapter.addOne(action.agent, state);

        case actions.AgentCustomActionTypes.ADD_AGENTS:
            return agentCustomAdapter.addMany(action.agents, state);

        case actions.AgentCustomActionTypes.UPSERT_AGENT:
            return agentCustomAdapter.upsertOne(action.agent, state);

        case actions.AgentCustomActionTypes.UPSERT_AGENTS:
            return agentCustomAdapter.upsertMany(action.agents, state);

        case actions.AgentCustomActionTypes.UPDATE_AGENT:
            return agentCustomAdapter.updateOne(action.agent, state);

        case actions.AgentCustomActionTypes.UPDATE_AGENTS:
            return agentCustomAdapter.updateMany(action.agents, state);

        case actions.AgentCustomActionTypes.DELETE_AGENT:
            return agentCustomAdapter.removeOne(action.id, state);

        case actions.AgentCustomActionTypes.DELETE_AGENTS:
            return agentCustomAdapter.removeMany(action.ids, state);

        case actions.AgentCustomActionTypes.DELETE_ALL:
            return agentCustomAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getAgentCustomState = createFeatureSelector<AgentCustomState>('agentCustom');

export const { selectIds, selectEntities, selectAll, selectTotal } = agentCustomAdapter.getSelectors(getAgentCustomState);
